module.exports = __webpack_public_path__ + "img/delete1-hover.91693016.svg";